// @flow

import styled from '@emotion/styled'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  image:
    | React.Element<'img'>
    | React.Element<typeof GatsbyImage>
    | React.Element<typeof StaticImage>,
  title: string,
  paragraph: string | React.Node,
|}

export function FeatureIcon({ image, title, paragraph }: Props) {
  return (
    <Root>
      {image}
      <Text>
        <Title>{title}</Title>
        <Paragraph>{paragraph}</Paragraph>
      </Text>
    </Root>
  )
}

const Root: React.ComponentType<any> = styled.div`
  padding: 15px 0;
  display: flex;
  img {
    flex: 0 0 40px;
    max-width: 50px;
    max-height: 100px;
    object-fit: contain;
  }
  ${media.mq[1]} {
    flex: 0 0 48%;
    flex-wrap: wrap;
    align-content: flex-start;
    padding: 15px 30px 15px 15px;
  }
  ${media.mq[2]} {
    flex: 0 0 32%;
    margin-bottom: 25px;
    img {
      max-width: 70px;
      max-height: 70px;
      margin-bottom: 10px;
    }
  }
`

const Text = styled.div`
  margin-left: 20px;
  flex: 1;
  ${media.mq[2]} {
    margin-left: 0;
    min-width: 100%;
  }
`

const Title = styled.h4`
  ${text.heading4};
  color: ${colors.almostWhite};
  margin: 10px 0;
`

const Paragraph = styled.p`
  ${text.paragraph2};
  color: ${colors.almostWhite};
  margin: 10px 0;
`
